import React from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../shared/BackButton/BackButton";
import styles from "./Lesson.module.css";

const Lessons = () => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <div className={styles.container}>
      <BackButton />
      <h1 className={styles.headerTitle}>Lesson Types</h1>
      <div className={styles.columns}>
        <div className={styles.column} onClick={() => handleNavigate("/lessons/fill-in-the-blank")}>
          <h2 className={styles.title}>Fill In The Blank</h2>
        </div>
        <div
          className={styles.column}
          onClick={() => handleNavigate("/lessons/sentence-translation")}
        >
          <h2 className={styles.title}>Sentence Translation</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/lessons/image-list")}>
          <h2 className={styles.title}>Image List</h2>
        </div>
      </div>
      <div className={styles.columns}>
        <div className={styles.column} onClick={() => handleNavigate("/lessons/objectives")}>
          <h2 className={styles.title}>Objectives</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/lessons/word-descriptions")}>
          <h2 className={styles.title}>Word Descriptions</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/lessons/words-to-describe")}>
          <h2 className={styles.title}>Words To Describe</h2>
        </div>
        <div
          className={styles.column}
          onClick={() => handleNavigate("/lessons/speech-sentence-practice")}
        >
          <h2 className={styles.title}>Speech Sentence Practice</h2>
        </div>
        <div
          className={styles.column}
          onClick={() => handleNavigate("/lessons/translation-mediator")}
        >
          <h2 className={styles.title}>Translation Mediator</h2>
        </div>
      </div>
    </div>
  );
};

export default Lessons;
